import React, { FC } from 'react';

import UtilFunctions from '~utils/functions';
import * as TextStyles from './_text.module.scss';

type TextProps = {
    label: string;
    size?: 's' | 'm' | 'l' | 'xl';
    isBold?: boolean;
    isUnderlined?: boolean;
    isError?: boolean;
    className?: string;
}

const Text: FC<TextProps> = ({
    label,
    size,
    isBold,
    isUnderlined,
    isError,
    className,
}) => {
    const styles = UtilFunctions.Styles.concatClassNames([
        className,
        TextStyles.container,
        (isBold ? TextStyles.bold : ''),
        (isError ? TextStyles.error : ''),
        (size ? TextStyles[`font-size-${size}`] : ''),
        (isUnderlined ? TextStyles.underline : ''),
    ]);

    return (
        <div className={styles}>
            {label}
        </div>
    );
};

export default Text;
